import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Backdrop,
  CircularProgress,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CheckAttr from "../../../../utils/CheckAttr";
import { DataRef } from "../../../../types/DataRef";
import { AlertType } from "../../../../types/AlertType";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import { convertBase64, downloadFile } from "../../../../utils/utils";
import {
  MODE_BUDGET,
  profilsCanManagePotentielClientOperation,
  PROFIL_ADV,
  PROFIL_DIRECTION,
  PROFIL_SUPER_ADMIN,
  PROFIL_SUPER_MANAGER,
  PROFIL_COUNTRY_MANAGER
} from "../../../../constants/Constants";
import Cookies from "universal-cookie";
import axios, { AxiosInstance } from "axios";
import { useSelector } from "react-redux";
import { Reducers } from "../../../../redux/reducers";
import UserInformation from "../../../../types/UserInformation";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { LoadingButton } from "@mui/lab";
import PublishIcon from "@mui/icons-material/Publish";
import FormData from "form-data";
import { urlApi } from "../../parametrage/Pays/RowPays";
import { btnStyle } from "../../parametrage/user/Tabs/utilisateur/UtilisateurRow";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

interface clientBudgetProd {
  id: number;
  libelle: string;
  budget?: string;
}

interface operationBudgetProd {
  id: number;
  libelle: string;
  budget?: string;
}

interface ExtractData {
  yearBudget: Dayjs | null;
  pays?: number;
  client?: string;
  operation?: string;
}

const initialData: ExtractData = {
  yearBudget: null,
  pays: undefined,
  client: undefined,
  operation: undefined,
};

const ImportBudget = () => {
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const user = useSelector<Reducers>(
    (state) => state.logger
  ) as UserInformation;

  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const httpWithExcel: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [openSnackLong, setOpenSnacklong] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<AlertType>("success");

  const [selectedFile, setSelectedFile] = useState(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const minDateOfBudgetYear = dayjs(new Date(new Date().getFullYear(), 0, 1));
  const maxDateOfBudgetYear = dayjs(
    new Date(new Date().getFullYear() + 1, 11, 31)
  );

  const [extractionData, setExtractionData] =
    useState<ExtractData>(initialData);

  const [dataPaysInAssociations, setDataPaysInAssociations] = useState<
    DataRef[]
  >([]);
  const [dataClients, setDataClients] = useState<clientBudgetProd[]>([]);
  const [dataOperations, setDataOperations] = useState<operationBudgetProd[]>(
    []
  );

  const ImportVisible = [
    PROFIL_SUPER_ADMIN,
    PROFIL_ADV,
    PROFIL_DIRECTION,
    PROFIL_SUPER_MANAGER,
    PROFIL_COUNTRY_MANAGER
  ].includes(user?.profils?.libelle)
    ? true
    : false;

  const handleDownLoad = () => {
    console.log(extractionData);
    if (CheckAttr(extractionData?.yearBudget)) {
      setLoading(true);
      http
        .post("budget/export-canva-budget", extractionData)
        .then((res) => {
          setAlerteMessage("Extraction Reussi");
          setAlertType("success");
          setOpenSnack(true);

          downloadFile(res.data.filename as string);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setAlerteMessage("Merci de choisir une année");
      setAlertType("warning");
      setOpenSnack(true);
    }
  };

  const handleImport = () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    console.log(selectedFile);
    if (CheckAttr(selectedFile) && CheckAttr(extractionData?.yearBudget)) {
      setLoading(true);
      httpWithExcel
        .post(`budget/import-canva/${extractionData?.yearBudget?.year()}`, formData)
        .then((res) => {
          if (res.data.is_saved === 0) {
            setAlertType("warning");
            setOpenSnacklong(true);
          } else {
            handleCloseModal();
            setAlertType("success");
            setOpenSnack(true);
          }

          setAlerteMessage(res.data.message);
        })
        .catch((error) => {
          setAlertType("warning");
          setAlerteMessage("Fichier incorrect, merci de téléchargé un canevas");
          setOpenSnack(true);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setAlertType("warning");
      setAlerteMessage("Merci de choisir une année et un fichier excel");
      setOpenSnack(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setExtractionData({
      ...extractionData,
      [name]: value,
    });
  };

  // File converti to BASE64..........
  const handleChangeFile = async (event: any) => {
    setSelectedFile(event.target.files[0]);
  };

  // Handle Change
  const handleChangeYearBudget = (e: any) => {
    setExtractionData({
      ...extractionData,
      yearBudget: dayjs(e),
    });
  };

  // get Data Ref
  const getPaysInAssociation = () => {
    // Récupère tous les pays qui existe dans l'association pays-bu
    http
      .get("pivot-client-bu/get-all-exist-pays-in-association")
      .then((res) => {
        Array.isArray(res.data) && setDataPaysInAssociations(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getClients = async () => {
    setDataClients([]);

    let url = null;
    if (CheckAttr(extractionData?.pays)) {
      url = `client/get-clients-via-pays/${extractionData?.pays}`;
    } else {
      if (
        profilsCanManagePotentielClientOperation.includes(
          user?.profils?.libelle
        )
      ) {
        url = "client/get-clients-via-pays";
      }
    }

    if (url) {
      setLoading(true);
      await http
        .get(url)
        .then((res) => {
          Array.isArray(res.data) && setDataClients(res.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const getOperation = () => {
    // Récupère les opérations du client sélectionné et pays sélectionné
    setLoading(true);
    const splitedClientValue = extractionData?.client?.split("_");
    const data = {
      pays: extractionData?.pays,
      budget: splitedClientValue && splitedClientValue[0] === MODE_BUDGET,
      client: splitedClientValue && Number(splitedClientValue[1]),
    };

    http
      .post("operation/get-operations/via-pays-client", data)
      .then((res) => {
        Array.isArray(res.data) && setDataOperations(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // UseEffect
  useEffect(() => {
    getPaysInAssociation();
    getClients();
  }, []);

  useEffect(() => {
    getClients();
    setExtractionData({
      ...extractionData,
      client: undefined,
      operation: undefined,
    });
    setDataOperations([]);
  }, [extractionData?.pays]);

  useEffect(() => {
    getOperation();
    setExtractionData({
      ...extractionData,
      operation: undefined,
    });
  }, [extractionData.client]);

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const handleCloseAlertLong = () => {
    setOpenSnacklong(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  const stackAlertLongDuration: JSX.Element = SnackBarAlert(
    openSnackLong,
    handleCloseAlertLong,
    alertType,
    alertMessage,
    true
  );
  return (
    <>
      <Container maxWidth="md" sx={{ mt: 10 }}>
        <Card sx={{ maxWidth: 845 }}>
          <CardMedia
            component="img"
            image="/images/import_budget.png"
            alt="green iguana"
            sx={{ display: { xs: "none", sm: "flex" }, height: 140 }}
          />

          <CardContent>
            <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl fullWidth variant="outlined" sx={{ marginTop: 1 }}>
                  <InputLabel
                    htmlFor="pays"
                    color="warning"
                    shrink={CheckAttr(extractionData?.pays)}
                  >
                    Pays de production
                  </InputLabel>
                  <Select
                    id="pays"
                    native
                    color="warning"
                    value={extractionData?.pays}
                    onChange={handleChange}
                    label="Pays de production"
                    inputProps={{
                      name: "pays",
                    }}
                  >
                    <option value=""></option>
                    {dataPaysInAssociations.map((pays) => (
                      <option key={pays?.id} value={pays?.id}>
                        {pays?.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl fullWidth variant="outlined" sx={{ marginTop: 1 }}>
                  <InputLabel
                    htmlFor="client"
                    color="warning"
                    shrink={CheckAttr(extractionData?.client)}
                  >
                    Client
                  </InputLabel>
                  <Select
                    id="client"
                    native
                    color="warning"
                    value={extractionData?.client}
                    onChange={handleChange}
                    label="Client"
                    inputProps={{
                      name: "client",
                    }}
                  >
                    <option value={undefined}></option>
                    {dataClients.map((client) => (
                      <option
                        key={client?.id}
                        value={
                          client?.budget === "budget"
                            ? `budget_${client?.id}`
                            : `prod_${client?.id}`
                        }
                      >
                        {client?.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl fullWidth variant="outlined" sx={{ marginTop: 1 }}>
                  <InputLabel
                    htmlFor="operation"
                    color="warning"
                    shrink={CheckAttr(extractionData?.operation)}
                  >
                    Opération
                  </InputLabel>
                  <Select
                    id="operation"
                    native
                    color="warning"
                    value={extractionData?.operation}
                    onChange={handleChange}
                    label="Opération"
                    inputProps={{
                      name: "operation",
                    }}
                  >
                    <option value={undefined}></option>
                    {dataOperations.map((operation) => (
                      <option
                        key={operation?.id}
                        value={
                          operation?.budget === "budget"
                            ? `budget_${operation?.id}`
                            : `prod_${operation?.id}`
                        }
                      >
                        {operation?.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl fullWidth variant="outlined" sx={{ marginTop: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Année"
                      views={["year"]}
                      value={extractionData?.yearBudget}
                      onChange={handleChangeYearBudget}
                      minDate={minDateOfBudgetYear}
                      maxDate={maxDateOfBudgetYear}
                      slotProps={{
                        textField: {
                          color: "warning",
                          fullWidth: true,
                          // error: errorInput?.yearProd,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <Box display="flex" justifyContent="center" mt={3}>
                  <LoadingButton
                    onClick={() => handleDownLoad()}
                    endIcon={<CloudDownloadIcon />}
                    loading={loading}
                    loadingPosition="end"
                    sx={{ textTransform: "none" }}
                    variant="contained"
                    color="warning"
                  >
                    Télécharger canevas
                  </LoadingButton>
                </Box>
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <Box display="flex" justifyContent="center" mt={1}>
                  <div>
                    <Typography display="initial">
                      <input
                        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        id="raised-button-file"
                        name="piecesJointes"
                        onChange={handleChangeFile}
                        multiple
                        type="file"
                      />
                    </Typography>
                    <br />
                    <Box display="flex" justifyContent="center" mt={1}>
                      <LoadingButton
                        onClick={() => setOpenModal(true)}
                        endIcon={<PublishIcon />}
                        loading={loading}
                        loadingPosition="end"
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        color="warning"
                      >
                        Importer
                      </LoadingButton>
                    </Box>
                  </div>
                </Box>
              </Grid>

              {/* {ImportVisible && (
                <Grid item xs={6} sm={6} md={6}>
                  <Box display="flex" justifyContent="center" mt={1}>
                    <div>
                      <Typography display="initial">
                        <input
                          accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          id="raised-button-file"
                          name="piecesJointes"
                          onChange={handleChangeFile}
                          multiple
                          type="file"
                        />
                      </Typography>
                      <br />
                      <Box display="flex" justifyContent="center" mt={1}>
                        <LoadingButton
                          onClick={() => setOpenModal(true)}
                          endIcon={<PublishIcon />}
                          loading={loading}
                          loadingPosition="end"
                          sx={{ textTransform: "none" }}
                          variant="contained"
                          color="warning"
                        >
                          Importer
                        </LoadingButton>
                      </Box>
                    </div>
                  </Box>
                </Grid>
              )} */}
            </Grid>
          </CardContent>
        </Card>
      </Container>

      {stackAlert}
      {stackAlertLongDuration}
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      <Dialog
        open={openModal}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation Importation Budget"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <FormControl fullWidth variant="outlined" sx={{ marginTop: 1 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Année"
                  views={["year"]}
                  value={extractionData?.yearBudget}
                  onChange={handleChangeYearBudget}
                  minDate={minDateOfBudgetYear}
                  maxDate={maxDateOfBudgetYear}
                  slotProps={{
                    textField: {
                      color: "warning",
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleImport()}
            startIcon={<PublishIcon />}
            loadingPosition="end"
            sx={btnStyle({
              bgColor: "#FF0000",
              hoverColor: "#FE3737",
            })}
            variant="contained"
            loading={loading}
          >
            Oui
          </LoadingButton>
          <LoadingButton
            onClick={() => handleCloseModal()}
            startIcon={<ExitToAppIcon />}
            sx={{ textTransform: "none" }}
            loadingPosition="end"
            variant="contained"
            color="inherit"
          >
            Non
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImportBudget;
